import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextEditor = ({ onChange, data, isInvalid = false }) => {
  const [editorContent, setEditorContent] = useState("");

  useEffect(() => {
    if (data && editorContent === "") {
      setEditorContent(data);
    }
  }, [data, editorContent]);

  const handleChange = (content) => {
    setEditorContent(content);
    onChange(content);
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      ["link", "image", "video"],
      [{ align: [] }],
      ["clean"], // remove formatting
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "align",
  ];

  return (
    <div className={`h-full ${isInvalid ? "is-invalid" : ""}`}>
      <ReactQuill
        className="h-full"
        value={editorContent}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        theme="snow"
        placeholder="Compose something awesome..."
      />
    </div>
  );
};

export default TextEditor;
